import { useIntl } from '@/intl'
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable'
import {
  carToBeSelected,
  showingExtraCars,
  useCarRentalServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { Button, ListItem, Sheet } from '@sunwebgroup/ui-components/uds/index'
import * as React from 'react'
import { styled } from 'styled-components'

const AddExtraCarsContentButton = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: row;
`

export function ExtraCarsView({ maxNumbersOfCarsToBeBooked }: { maxNumbersOfCarsToBeBooked: number }) {
  const intl = useIntl()
  const { service } = useService(ServiceType.CarRentalFiltering)
  const { setShowExtraCars } = useCarRentalServiceStore()
  const isShowingExtraCars = useCarRentalServiceStore(showingExtraCars)
  const selectingCar = useCarRentalServiceStore(carToBeSelected)

  if (maxNumbersOfCarsToBeBooked <= 1)
    return null
  if (!service)
    return null
  const { options } = service
  const selectingCarOption = selectingCar ? options?.[selectingCar] : null

  return (
    <>
      <Sheet.Root
        open={isShowingExtraCars}
        onOpenChange={(open) => {
          setShowExtraCars(open)
        }}
      >
        {!selectingCarOption && (
          <Sheet.Trigger>
            <ListItem variant="outlined">
              <AddExtraCarsContentButton onClick={() => setShowExtraCars(true)}>
                <Button $type="secondary">{intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_extra_cars_add_button' })}</Button>
              </AddExtraCarsContentButton>
            </ListItem>
          </Sheet.Trigger>
        )}

        <Sheet.Body side="bottom" hasPadding={false}>
          <Sheet.Header titleLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_title' })} closeLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_close_text' })} />
          <FilterableCarsAvailable />
        </Sheet.Body>
      </Sheet.Root>
    </>
  )
}
